import { SxProps, Theme } from "@mui/material/styles";

export const FONT_WEIGHT = {
  NORMAL: "normal",
  BOLD: "bold",
} as const;

export const FONT_SIZE = {
  heroTitle: "40px",
  headline4: "33px",
  headline5: "24px",
  headline6: "20px",
  body1: "16px",
  body2: "14px",
  subtitle1: "16px",
  subtitle2: "14px",
  caption: "12px",
} as const;

export const TEXT_COLOR = {
  PRIMARY: "#000000de",
  SECONDARY: "#00000099",
  DISABLED: "#00000061",
  SUCCESS: "#1fb43f",
  CONTRAST: "#FFFFFF",
};

export const BACKGROUND_COLOR = {
  PRIMARY: "#1fb43f",
  SECONDARY: "#F4F9FC",
  SECONDARY_DARK: "#DAECF4",
  WHITE: "#FFFFFF",
  GRAY: "#616161",
  INHERIT: "#F5F5F5",
  WARNING: "#ED5C74",
  INFO: "#3E99C4",
  BORDER: "#CCDFEA",
  BORDER_DARK: "#C4C4C4",
  HIGHLIGHT: "#1FB43F1A"
};

// グラフ用カラー
export const COLOR_EV_BAR = "#3f51b5"; // EV営収(バー）
export const COLOR_EV_LINE = "#283593"; // EV走行距離(ライン）
export const COLOR_LPG_BAR = "#e57373"; // LPG営収(バー）
export const COLOR_LPG_LINE = "#c62828"; // LPG走行距離(ライン）

// 軸ID
export const AXIS_LEFT = "left";
export const AXIS_RIGHT = "right";

export const SECTION_CARD_SX: SxProps<Theme> = {
  p: 5,
  borderRadius: 3,
  bgcolor: BACKGROUND_COLOR.WHITE,
  border: `1px solid ${BACKGROUND_COLOR.INHERIT}`,
  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
};

export const GO_FURTHER_BASE_LINE_HEIGHT = 1.25;

export const GO_FURTHER_PAGE_SX = {
  lineHeight: GO_FURTHER_BASE_LINE_HEIGHT,
  "& .MuiTypography-root, & .MuiLink-root, & p, & a, & li": {
    lineHeight: "inherit",
  },
} as const;
